import React from 'react';
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PassList from '../../components/pass-list'
import PassViewMenu from '../../components/pass-view-menu'
import { selectPassInPassList, selectPassView } from '../../reducers/ui-control'
import Collapse from '@material-ui/core/Collapse'
import { PassShape } from '../../specs'
import { PASS_VIEWS } from '../../util/constants'
import NewPassModule from '../../modules/new-pass/index'
import HistoryList from '../../components/history-list'
const selectors = {
  getSelectedPassId: state => {
    return state.uiControl.selectedPassId ? state.uiControl.selectedPassId : null
  },
  getPassView: state => {
    return state.uiControl.passView
  }
}
const styles = theme => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3
  }
});
const ResidentPage = ({ classes, passes, history, selectPass, selectedPassId, passView, selectPassView }) => {
  return (
    <div className={classes.root}>
      <Paper>
        <Collapse direction="right" appear={false} in={passView === PASS_VIEWS.ACTIVE} unmountOnExit>
          <PassList passes={passes} selectPass={selectPass} selectedPassId={selectedPassId} />
        </Collapse>
        <Collapse direction="left" appear={false} in={passView !== PASS_VIEWS.ACTIVE} unmountOnExit>
          <HistoryList history={history} selectedPassId={selectedPassId} />
        </Collapse>
      </Paper>
      <PassViewMenu value={passView} onChange={selectPassView} />
      <NewPassModule />
    </div>
  );
}

ResidentPage.propTypes = {
  classes: PropTypes.object.isRequired,
  passes: PropTypes.arrayOf(PassShape),
  history: PropTypes.array.isRequired,
  selectPass: PropTypes.func.isRequired,
  selectedPassId: PropTypes.string,
  passViewValue: PropTypes.string
};

const mapStateToProps = (state) => ({
  passes: state.passList.passes,
  history: state.passList.history,
  selectedPassId: selectors.getSelectedPassId(state),
  passView: selectors.getPassView(state)
});
const mapDispatchToProps = dispatch => bindActionCreators({
  selectPass: selectPassInPassList,
  selectPassView: selectPassView
}, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ResidentPage));


// WEBPACK FOOTER //
// ./src/pages/resident/index.js